import {exportStockUrl} from "@/api/gift";

export default {
    methods: {
        onCopy(content) {
            const text = String(content)
            this.$copyText(text).then(() => {
                this.$message.success('复制成功：' + text)
            })
        },
        handleExport(exportUrl, query = {}) {
            this.$linkHelper.redirect(exportUrl, query)
        },
    }
}
